module.exports = __webpack_public_path__ + "static/media/6dustyCreamA4028.b1dc6189.PNG";